/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getSurveyAssurancePortfolios } from '../../../actions/assurance';
import { SurveyModelMinData } from '../../../types/survey';
import { AssurancePortfolio } from '../../../types/assurance';
import CompanyAssurancePortfolio from '@features/assurance/company-assurance-portfolio';
import { Loader } from '@g17eco/atoms/loader';

interface AssurancePortfoliosListData {
  assurances?: AssurancePortfolio[];
  survey?: SurveyModelMinData;
}

interface AssurancePortfoliosListState extends AssurancePortfoliosListData {
  loaded: boolean;
  error: boolean;
  errorMessage?: string;
}

const listInitialState: AssurancePortfoliosListState = {
  loaded: false,
  error: false,
  errorMessage: undefined
}

interface SurveyAssuranceProps {
  surveyId: string;
}

const SurveyAssurance = (props: SurveyAssuranceProps) => {
  const { surveyId } = props;

  const route = useRouteMatch < { assuranceId?: string }>();
  const [assuranceData, setAssuranceData] = React.useState<AssurancePortfoliosListState>(listInitialState);

  React.useEffect(() => {
    if (!surveyId) {
      return;
    }

    getSurveyAssurancePortfolios(surveyId)
      .then((data: AssurancePortfoliosListData) => {
        setAssuranceData({
          ...listInitialState,
          survey: data.survey,
          assurances: data.assurances,
          loaded: true
        });
      })
      .catch((e: Error) => {
        setAssuranceData({
          ...listInitialState,
          loaded: true,
          error: true,
          errorMessage: e.message
        });
      });
  }, [surveyId]);

  if (!assuranceData.loaded) {
    return <Loader />;
  }

  if (!assuranceData.assurances || assuranceData.assurances.length === 0) {
    // @TODO
    return <>Error: No assurances</>;
  }

  const assuranceId = route.params.assuranceId ?? assuranceData.assurances[0]._id;

  return <CompanyAssurancePortfolio assurancePortfolioId={assuranceId} />
}

export default SurveyAssurance;
